import { render, staticRenderFns } from "./ColumnBlock.vue?vue&type=template&id=592a5fcc&scoped=true&"
import script from "./ColumnBlock.vue?vue&type=script&lang=js&"
export * from "./ColumnBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColumnBlock.vue?vue&type=style&index=0&id=592a5fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a5fcc",
  null
  
)

export default component.exports